import {
  Box,
  Card,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid
} from '@mui/material'
import { Loading, useTranslate } from 'react-admin'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { groupBy, isEmpty, isNil, isObject, keys, map, split } from 'lodash/fp'
import { useGetAnnounces } from 'components/DataProvider'
import { type AnnounceItem } from '../../../../cdk/bapp/lib/lambda-api/src/types'
import { format, parseISO } from 'date-fns/fp'
import log from 'loglevel'
import { type ReactElement } from 'react'

log.setLevel(log.levels.DEBUG)

const env = process.env['ENV'] as string
const urlBase = `https://${
  {
    prd: 'sapp-v2.terashite.jp',
    stg: 'sapp-v2-stg.terashite.jp',
    int: 'sapp-v2-int.dev.terashite.jp',
    dev: 'sapp-v2.dev.terashite.jp',
    exp: 'sapp-v2--exp.dev.terashite.jp'
  }[env] as string
}/files`

const normalizeDate = (dateString: string): string => {
  const [year, month, day] = split('-')(dateString)
  return `${year as string}-${month?.padStart(2, '0') as string}-${
    day?.padStart(2, '0') as string
  }`
}
export const drawAnnounces = (data: AnnounceItem[]): ReactElement[] => {
  const dataByDate = groupBy<AnnounceItem>('date')(data)
  return map((date: string | Date) => {
    const dateValue = isObject(date) ? date : parseISO(normalizeDate(date))
    // @ts-expect-error ts(2339)
    return map.convert({ cap: false })((item: AnnounceItem, index: number) => {
      const { content, file, partner } = item
      return (
        <Grid container sx={{ ml: '2em', mb: '1em' }} key={index}>
          <Grid size={{ xs: 3, md: 2 }}>
            {index === 0 ? (
              <Typography variant="body1">
                {format('yyyy年M月d日')(dateValue)}
              </Typography>
            ) : null}
          </Grid>
          <Grid size={{ xs: 9, md: 10 }}>
            <>
              {
                // @ts-expect-error ts(2339)
                map.convert({ cap: false })(
                  (line: string, subindex: number) => {
                    if (isEmpty(line))
                      return <br key={`${index}-${subindex}`} />
                    const url = line.match(/https?:\/\/[\w/:%#$&?()~.=+-]+/)
                    if (isNil(url)) {
                      return (
                        <Typography
                          variant="body2"
                          key={`${index}-${subindex}`}
                          sx={{ mb: '0.3em' }}>
                          {line}
                        </Typography>
                      )
                    } else {
                      const items = split(url[0])(line)
                      return (
                        <Box sx={{ mb: '0.3em' }} key={`${index}-${subindex}`}>
                          <Typography
                            component="span"
                            variant="body2"
                            key={`${index}-${subindex}-0`}>
                            {items[0]}
                          </Typography>
                          <div key={`${index}-${subindex}-1`}>
                            <a href={url[0]}>{url[0]}</a>
                          </div>
                          <Typography
                            component="span"
                            variant="body2"
                            key={`${index}-${subindex}-2`}>
                            {items[1]}
                          </Typography>
                        </Box>
                      )
                    }
                  }
                )(split('\n')(content))
              }
              {!isNil(file) && !isEmpty(file) && (
                <div key={`${index}-url`}>
                  <a
                    href={`${urlBase}${
                      isNil(partner) ? '/' : '/' + partner + '/'
                    }${file}`}
                    target="_blank">
                    ダウンロード
                  </a>
                </div>
              )}
            </>
          </Grid>
        </Grid>
      )
    })(dataByDate[date])
  })(keys(dataByDate))
}

export const Announce: React.FC<{ partner: string }> = ({ partner }) => {
  const translate = useTranslate()
  const { isLoading, data } = useGetAnnounces(partner)
  if (isLoading as boolean) return <Loading />
  // if (isEmpty(data)) return null
  return (
    <Card raised sx={{ width: '100%', marginTop: '1em' }}>
      <Accordion
        defaultExpanded={!isEmpty(data)}
        sx={{ backgroundColor: 'white' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography
            variant="h5"
            sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            {translate('resources.announce.title')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>{drawAnnounces(data)}</AccordionDetails>
      </Accordion>
    </Card>
  )
}
